import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Lock } from '../../models/lock';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LockService } from '../../services/lock.service';
import { StationService } from '../../services/station.service';
import { ToastsManager } from 'ng2-toastr';
import { GroupLight } from '../../models/group';
import { GroupService } from '../../services/group.service';
import { AccountService } from '../../services/account.service';

import { BikeService } from '../../services/bike.service';
import { Bike } from '../../models/bike';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-locks-form',
  templateUrl: './locks-form.component.html',
  styleUrls: ['./locks-form.component.css']
})
export class LocksFormComponent implements OnInit {

  lock: Lock;

  visibleGroups: GroupLight[];

  groupId : any = 'no-group';

  creationMode: boolean;
  @Output() onUpdateValidation = new EventEmitter<Lock>();
  @Output() onCreateValidation = new EventEmitter<boolean>();


  constructor(public activeModal: NgbActiveModal,
    public lockService: LockService,
    public accountService : AccountService,
    private groupService: GroupService,
    private toast: ToastsManager,
    public translate : TranslateService) {

  }

  ngOnInit() {
    // Loading groups to display
    this.groupService.loadVisibleGroups().subscribe(res => {
      this.visibleGroups = res;
    });

    if (this.lock.groupId) {
      this.groupId = this.lock.groupId;
      this.changeGrp();
    }
  }

  changeType(input: string) {
    this.lock.type = input;
  }

  changeGrp() {
    if (this.groupId == undefined || this.groupId == 'no-group') {
      this.lock.groupId = undefined;
      this.lock.groupName = undefined;
      
    } else {
      this.lock.groupId = this.groupId;
    }
  }

  onSaveClick() {
    if (this.creationMode) {
      this.lockService.post(this.lock).subscribe(lock => {
        this.toast.success(this.translate.instant("toast.lockcreated"), this.translate.instant("toast.success"));
        this.activeModal.close();
        this.onCreateValidation.emit(true);
      });
    } else {
      this.lockService.put(this.lock).subscribe(lock => {
        this.toast.success(this.translate.instant("toast.lockupdated"), this.translate.instant("toast.success"));
        this.onUpdateValidation.emit(this.lock);
        this.activeModal.close();
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/locks/locks-form/locks-form.component.ts